import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import {
	getCustomerRegistration,
} from 'services/customer-registration.service';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import NavPills from 'components/NavPills/NavPills';
import ReadOnlyField from 'components/ReadOnlyField/ReadOnlyField';
import AuditLog from 'components/AuditLog/AuditLog';

const styles = {
	'details-container': {
		borderBottom: '1px solid #000',
	},
	receivedByContainer: {
		marginTop: '50px',
	},
};

class CustomerRegistrationDetails extends Component {
	state = {
		customerRegistration: null,
	};

	async componentDidMount() {
		await this.getRecordDetails(); // need to await to get record name
		this.props.setPageHeaderText(this.state?.customerRegistration?.name);
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	async getRecordDetails() {
		try {
			const id = this.props.match?.params?.id;

			if (id) {
				this.setState({
					isLoading: true,
				});

				const customerRegistration = await getCustomerRegistration(id);
				this.setState(() => ({
					isLoading: false,
					customerRegistration,
				}));
			}
		} catch (error) {
			console.log(error);
		}
	}

	render() {
		const {
			createdAt,
			deviceType,
			name,
			phoneNumber,
			token,
			updatedAt,
			osVersion,
			deviceModel,
			networkCarrier,
		} = this.state.customerRegistration || {};

		return (
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardBody>
							<NavPills
								color="warning"
								tabs={[
									{
										tabButton: 'Details',
										tabContent: (
											<div className="details-container">
												<div>
													<ReadOnlyField
														label="Name"
														value={name || ''}
													/>
													<ReadOnlyField
														label="Phone Number"
														value={
															phoneNumber || ''
														}
													/>
													<ReadOnlyField
														label="Device model"
														value={
															deviceModel || ''
														}
													/>
													<ReadOnlyField
														label="OS version"
														value={
															osVersion || ''
														}
													/>
													<ReadOnlyField
														label="Network carrier"
														value={
															networkCarrier || ''
														}
													/>
													<ReadOnlyField
														label="Token"
														value={token || ''}
													/>
												</div>
											</div>
										),
									},
									{
										tabButton: 'Audit Log',
										tabContent: (
											<AuditLog
												createdBy={deviceType}
												createdAt={createdAt}
												modifiedBy={deviceType}
												modifiedAt={updatedAt}
											/>
										),
									},
								]}
							/>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}

CustomerRegistrationDetails.propTypes = {
	classes: PropTypes.any,
	setPageHeaderText: PropTypes.func,
	location: PropTypes.object,
	match: PropTypes.any,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch
	),
});

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(CustomerRegistrationDetails)
);
